export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between mb-6 md:mb-8">
      <div>
        <h1 className="text-xl md:text-2xl font-semibold text-text-primary">{title}</h1>
        {subtitle && <p className="text-sm text-text-secondary mt-1">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-3">{children}</div>}
    </div>
  );
}
